// extracted by mini-css-extract-plugin
module.exports = {"cover":"Dialog_cover__ojpYF","dialog":"Dialog_dialog__vczvK","title":"Dialog_title__Mm2E8","body":"Dialog_body__wfRjZ","footer":"Dialog_footer__QQRSC"};